import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";

const SOCIALS = [
    {
        name: 'X (Twitter)',
        href: 'https://x.com/Rawiyaih',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M18.244 2H21l-6.52 7.45L22 22h-6.83l-4.78-6.27L4.8 22H2l7.04-8.04L2 2h6.94l4.32 5.7L18.24 2Zm-1.2 18.2h1.51L7.05 3.7H5.43l11.61 16.5Z"/>
            </svg>
        ),
    },
    {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/96919158/',
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.95v5.66H9.36V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.61 0 4.28 2.37 4.28 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.8 0 0 .78 0 1.74v20.52C0 23.22.8 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.74V1.74C24 .78 23.2 0 22.22 0Z"/>
            </svg>
        ),
    },
];

// Forwarded to the team inbox by Cloudflare Email Routing (rawiyaih.com has no
// mailbox of its own). Change it here and in the routing rule together.
const CONTACT_EMAIL = 'contact@rawiyaih.com';

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-brand">
                    <div className="footer-logo">راوية</div>
                    <p className="footer-tagline">مجتمع الكتّاب والروائيين العرب</p>
                </div>

                <nav className="footer-links" aria-label="روابط">
                    <Link to="/library">المكتبة</Link>
                    <Link to="/register">إنشاء حساب</Link>
                </nav>

                <div className="footer-contact">
                    <span className="footer-contact-label">للأسئلة والاقتراحات</span>
                    <a href={`mailto:${CONTACT_EMAIL}`} className="footer-contact-email" dir="ltr">
                        {CONTACT_EMAIL}
                    </a>
                </div>

                <div className="footer-socials">
                    {SOCIALS.map(s => (
                        <a
                            key={s.name}
                            href={s.href}
                            className="footer-social-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={s.name}
                        >
                            {s.icon}
                        </a>
                    ))}
                </div>
            </div>
            <div className="footer-bottom">
                © {year} راوية. جميع الحقوق محفوظة.
            </div>
        </footer>
    );
}
